import Vue from 'vue'
import VueRouter from 'vue-router'

import i18n from '@/lang'  // 引入 i18n 实例

// 支持的语言列表（与语言包对应）
const supportedLangs = ['en', 'jp', 'zh']  // zh 是默认中文


import StartView from '@/pages/start.vue'
import HomeView from '@/pages/home.vue'
import LoginView from '@/pages/login.vue'
import WodeView from '@/pages/wode.vue'

import saima_a from '@/pages/saima_a'
import saima_b from '@/pages/saima_b'


Vue.use(VueRouter)



const routes = [{
		path: '',
		component: HomeView
	}, {
		path: 'start',
		component: StartView
	}, {
		path: 'home',
		component: HomeView
	}, {
		path: 'login',
		component: LoginView
	}, {
		path: 'wode',
		component: WodeView
	}, {
		path: 'desktop-1',
		component: saima_a
	}, {
		path: 'portable-1',
		component: saima_b
	}

]

console.log(routes)

const router = new VueRouter({
	mode: 'history',
	// base: process.env.BASE_URL,
	routes: [

		{
			path: '/:lang(en|zh|jp|en-US|ja-JP)', // 动态语言参数（en/jp/...）
			component: {
				render: h => h('router-view') // 占位组件，用于嵌套子路由
			},
			children: routes
		},
		{
			path: '/', // 动态语言参数（en/jp/...）
			component: {
				render: h => h('router-view') // 占位组件，用于嵌套子路由
			},
			children: routes
		},
	]
})

router.beforeEach((to, from, next) => {
  // 1. 从路由参数中获取语言（如 /en/home → to.params.lang = 'en'）
  let lang = to.params.lang

  // 2. 处理默认语言（无前缀时默认为 'zh'）
  if (!lang) {
    lang = 'ja-JP'
  }

  // 3. 校验语言是否支持（不支持则强制使用默认语言）
  // if (!supportedLangs.includes(lang)) {
  //   lang = 'zh'
  //   // 如果语言不支持，重定向到默认语言路由（如 /invalid → /home）
  //   return next(to.fullPath.replace(`/${to.params.lang}`, ''))
  // }

  // 4. 设置当前语言
  i18n.locale = lang

  next()
})

// 全局捕获路由错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		// 处理重复导航错误
		if (err.name !== 'NavigationDuplicated') {
			throw err // 其他错误继续抛出
		}
	})
}

export default router